
import { Component, OnInit, Inject } from '@angular/core';
import { identifierModuleUrl } from '@angular/compiler';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';
import { DgHubClientService, SettingsRequest, Settings, ViewSettingsReq, Views, StorePriceRangeReq } from 'src/app/Services/dg-hub-client.service';
import { DrawingService } from 'src/app/Services/DrawingService';
import { CookiesService } from 'src/app/Services/cookieService';
import { StoreScaleRangeReq } from '../../Services/dg-hub-client.service';
import { LoggerService } from '../../Services/Logger/Logger';

@Component({
  selector: 'app-views-dialog',
  templateUrl: './views-edit.component.html',
  styleUrls: ['./views-edit.component.css']
})


export class ViewsEditDialogComponent implements OnInit {

  public showViewEdit:boolean = false;
  private _views: Views[];
  public get views(): Views[] {
    return this._views;
  }
  public set views(value: Views[]) {
    this._views = value;
  }

  private _disabled: boolean = true;
  public get disabled(): boolean {
    return this.settingsForm.controls["viewName"].value==null || this.settingsForm.controls["viewName"].value=='';
  }
  public set disabled(value: boolean) {
    this._disabled = value;
  }

  constructor(
    public dialogRef: MatDialogRef<ViewsEditDialogComponent>,
    private fb: FormBuilder,
    public dgCLientService:DgHubClientService,
    private cookieService: CookiesService,
    public drawingService:DrawingService
    ) {

  }

  settingsForm = this.fb.group({
    viewName: [null],
    selectedview: [null],
  })

  ngOnInit() {

    this.dgCLientService.GetViewsList().then(v=>{
      this.views = Object.assign([], v.views);
    })


  }

  loadViewsList()
  {
    this.dgCLientService.GetViewsList().then(v=>{
      this.views = Object.assign([], v.views);
      this.drawingService.newViewResponse.next(v);
    })
  }

  saveView(viewId:number)
  {

    let find = this.views.find((v)=>{
      return v.id == viewId
    })

    this.dgCLientService.UpdateView(find).then(v=>{

        this.loadViewsList();

    }).catch((e)=>{
      LoggerService.logError(e);
    })

  }

  deleteView(viewId:number)
  {
    let find = this.views.find((v)=>{
      return v.id == viewId
    })

    this.dgCLientService.DeleteView(find).then(v=>{

        this.loadViewsList();

    }).catch((e)=>{
      LoggerService.logError(e);
    })
  }

  changeName(event, viewId)
  {

    let find = this.views.find((v)=>{
      return v.id == viewId
    })

    if(event.currentTarget.value!="")
    {
      find.viewName = event.currentTarget.value
    }

  }

  onConfirm(): void {

    this.drawingService.saveOrUpdateView(this.settingsForm.controls["viewName"].value)
      this.dialogRef.close();

  }


  onDismiss(): void {
    // Close the dialog, return false


    this.dialogRef.close(false);
  }

  close()
  {
    this.dialogRef.close(false);
  }
}
